import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { data } from 'services';
import { getRacks } from 'services/types';
import { Select, Multiselect } from './fields';
import { MultiInput } from './multi-input';

export const SourceFilter = (props) => {
  const { multiple } = props;
  const { t } = useTranslation();

  const [source, setSource] = useState(multiple ? [] : '');
  const [racks, setRacks] = useState([]);

  const getItemsAll = () => {
    const dict = data.getDict();
    if (!dict) {
      return [
        { name: t('source_filter.Сервер'), value: 'rack.server' },
        { name: t('source_filter.Касса'), value: 'rack.cashbox' },
        { name: t('source_filter.АПП'), value: 'rack.payment' },
        { name: t('source_filter.Стойка'), value: 'rack.lane' },
      ];
    }

    if (props.sources) {
      return dict[props.sources].items;
    }

    return dict.source_report.items;
  };

  const itemsAll = getItemsAll();
  const racks0 = data.getRacks();

  useEffect(() => {
    // get racks for filter
    if (!racks0) {
      getRacks(
        props.parkingId,
        (items) => {
          data.setRacks(items);
          setRacks(items);
        },
        []
      );
    } else {
      setRacks(racks0);
    }
  }, [props.parkingId]);

  /**
   * get filtered sources
   * @param {*} type
   * @param {*} out
   * @param {*} asElement
   */
  const filterBySource = (type, out, asElement = true) => {
    if (Array.isArray(source) ? source.length === 0 || source.includes(type) : !source || source === type) {
      let items = source ? racks.filter((el) => el.type === type) : [...racks];

      if (props.parkingIdLocal) {
        items = items.filter((el) => el.parking_id === props.parkingIdLocal);
      }
      const sortKey = 'mapped_name';
      items
        .sort((a, b) => {
          if (a[sortKey] > b[sortKey]) {
            return 1;
          }
          if (a[sortKey] < b[sortKey]) {
            return -1;
          }
          return 0;
        })
        .forEach((el) => {
          out.push(
            asElement ? (
              <option key={el.id} value={el.id}>
                {el.mapped_name}
              </option>
            ) : (
              { id: el.id, name: el.mapped_name }
            )
          );
        });
    }
  };

  /**
   * change source
   * @param {*} data
   */
  const sourceChange = (data) => {
    if (multiple) {
      setSource(data);
    } else {
      setSource(data.target.value);
    }
  };

  /**
   * get options for source filter
   * @returns
   */
  const getSources = () => {
    const out = [];
    const exclude = props.exclude;

    // sources types
    const items = itemsAll.filter((el) => {
      if (exclude) {
        return !exclude.includes(el.value);
      }
      return true;
    });

    // sources
    // if selected source
    if (source) {
      items.forEach((el) => {
        filterBySource(el.value, out, !multiple);
      });
    } else {
      filterBySource('', out, !multiple);
    }
    return out;
  };

  /**
   * get options for source type filter
   * @returns
   */
  const getOptions = () => {
    const exclude = props.exclude;
    const items = itemsAll.filter((el) => {
      if (exclude) {
        return !exclude.includes(el.value);
      }
      return true;
    });

    const out = items.map((el, idx) => {
      return multiple ? (
        { id: el.value, name: el.name }
      ) : (
        <option key={idx + 1000} value={el.value}>
          {el.name}
        </option>
      );
    });
    return out;
  };

  const options = getOptions();
  const sources = getSources();
  const title = t('grid.№ устройства');
  const titleType = t('grid.Источник');

  return (
    <>
      {multiple ? (
        <Multiselect type="multiselect" label={titleType} additionalComponent={MultiInput} data={options} width={'140px'} name="source_type" onChange={sourceChange} />
      ) : (
        <Select width="140px" name="source_type" type="select" label={titleType} onChange={sourceChange}>
          <option value="">{t('filter.Все')}</option>
          {options}
        </Select>
      )}

      {multiple ? (
        <Multiselect type="multiselect" label={title} additionalComponent={MultiInput} data={sources} width={'140px'} name="source" />
      ) : (
        <Select width="140px" name="source" type="select" label={title}>
          <option value="">{t('filter.Все')}</option>
          {sources}
        </Select>
      )}
    </>
  );
};
